import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["container", "listIcon", "gridIcon"]

    toggleView() {
        const className = "list-view";
        const activeClasses = ["bg-blue", "text-white"]
        if (!this.containerTarget.classList.contains(className)) {
            this.containerTarget.classList.add(className);
            this.listIconTarget.classList.add(...activeClasses);
            this.gridIconTarget.classList.remove(...activeClasses);
        } else {
            this.containerTarget.classList.remove(className);
            this.listIconTarget.classList.remove(...activeClasses);
            this.gridIconTarget.classList.add(...activeClasses);
        }
    }
}